import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'MerchantMarketing',
        path: () => path.join(__dirname, './MerchantMarketing'),
        resolve: () => require.resolveWeak('./MerchantMarketing'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "MerchantMarketing" */ './MerchantMarketing'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
